import { render, staticRenderFns } from "./LocalSearchResult.vue?vue&type=template&id=1874e13e"
import script from "./LocalSearchResult.vue?vue&type=script&lang=js"
export * from "./LocalSearchResult.vue?vue&type=script&lang=js"
import style0 from "./LocalSearchResult.vue?vue&type=style&index=0&id=1874e13e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports